import { Col, Row } from "react-bootstrap";
import WardList from "../components/admin/wards/WardList";
import DashboardCard from "../components/admin/DashboardCard";
import AdminLayout from "./layout/AdminLayout";
const AdminDashboard = () => {
  return (
    <AdminLayout>
      <Row>
        {/* <h1 className="title mb-4">Dashboard</h1> */}
        <Col className="container mb-4">
          <DashboardCard />
        </Col>
      </Row>
    </AdminLayout>
  );
};

export default AdminDashboard;
